import { lazy, useContext } from "react";
import BaseLayout from "./layouts/BaseLayout";
import SidebarLayout from "./layouts/SidebarLayout";
import { Navigate, RouteObject } from "react-router-dom";
import { SidebarContext } from "./contexts/SidebarContext";
const Login = lazy(() => import("./pages/authentication/login"));
const EmailVerification = lazy(
  () => import("./pages/authentication/emailVerification/components")
);
const ResetPasswordForm = lazy(
  () => import("./pages/authentication/password/components/resetPassword")
);
const ForgotPasswordForm = lazy(
  () => import("./pages/authentication/password/components/forgotPassword")
);
const OktaLogin = lazy(() => import("./pages/authentication/okta"));
// import Home from "./pages/dashboard/components/home";

let appRoutes: RouteObject[];

const Router = () => {
  const { routes } = useContext(SidebarContext);
  const isAuthenticated = localStorage.getItem("token") ? true : false;

  appRoutes = [
     {
          path: "/okta/login",
          element: <OktaLogin />,
        },
    {
      path: "",
      element: <BaseLayout />,
      children: [
        // {
        //   path: "",
        //   element: <Home />,
        // },
        {
          path: "/",
          // element: <Login />,
          element: isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login />
          ),
        },
        {
          path: "/login",
          // element: <Login />,
          element: isAuthenticated ? (
            <Navigate to="/admin-dashboard/dashboardV2" replace />
          ) : (
            <Login />
          ),
        },
        {
          path: "/verify-email/:id",
          element: <EmailVerification />,
        },
        {
          path: "/forgot-password",
          element: <ForgotPasswordForm />,
        },
        {
          path: "/reset-password/:id",
          element: <ResetPasswordForm />,
        },
        {
          path: "/email-verification/:id",
          element: <ResetPasswordForm />,
        },
        {
          path: "/login-with-otp",
          element: <Login path="login-with-otp" />,
        },       
      ],
    },
    {
      element: <SidebarLayout />,
      children: routes?.concat([
        {
          path: "*",
          element: <Navigate to="" replace />,
        },
      ]),
    },
  ];

  return appRoutes;
};

export default Router;
